<!-- no divs here to integrate nicely into parent -->
<p-dialog
  appendTo="body"
  [(visible)]="jobConfigurationVisible"
  styleClass="jobConfigurationOverlay"
  [modal]="true" [blockScroll]="true"
  (onHide)="hideJobConfiguration()"
  [header]="'cs.sys.reporting.contextJobConfigurationName' | hisUi">

  @for (setting of settings; track setting) {
    <his-job-setting [setting]="setting"></his-job-setting>
  }

  <ng-template #footer>
    <button type="button" [disabled]="!areSettingsValid(settings)" (click)="startJobClicked.emit(); hideJobConfiguration()">{{'de.his.javang.submit' | hisUi}}</button>
    <button type="button" (click)="hideJobConfiguration()">{{'common.cancel' | hisUi}}</button>
  </ng-template>
</p-dialog>
